module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__thank-you--section"
  }, [(_vm.alreadySent === false) ? _c('div', {
    staticClass: "system-builder__thank-you--container"
  }, [_c('h1', [_vm._v("Thank you for providing feedback.")]), _vm._v(" "), _c('p', [_vm._v("Have fun with your new Compustar system.")])]) : _c('div', {
    staticClass: "system-builder__thank-you--container"
  }, [_c('h1', [_vm._v("This request is closed")]), _vm._v(" "), _c('p', [_vm._v("Thank you for providing your feedback.")]), _vm._v(" "), _c('a', {
    staticClass: "button__solid--blue",
    on: {
      "click": _vm.goToViewSystem
    }
  }, [_vm._v("Request Another Quote")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-917537f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/ThankYou.vue
// module id = 430
// module chunks = 1